import { ProvinceService } from "../../services/models/province";
const moduleProvince = {
	namespaced: true,
	state: {
		provinces: [],
		loading: false,
	},
	getters: {
		getProvinces(state) {
			return state.provinces;
		},
		getLoading(state) {
			return state.loading;
		}
	},
	mutations: {
		loadProvinces(state, provinces) {
			state.provinces = provinces;
		}
	},
	actions: {
		async loadProvinces({ commit, state }) {
			state.loading = true;
			let provinces = await ProvinceService.getAll();
			commit("loadProvinces", provinces);
			state.loading = false;
		}
	}
}

export default moduleProvince;